// qualityAuditSummary — resume um evento quality_audit do loop em telemetria
// COUNTS-ONLY (self-learning→skills W3): total/erros/byType, sem paths nem
// mensagens (no-PII, mesmo contrato do turn_telemetry). Puro e determinístico
// (invariante do loop/ core); o SessionWorkspace persiste o resultado via
// observe('quality_audit', …) → POST /api/learning/events/batch → session_events,
// onde o patternDetector pode minerar a qualidade da ENTREGA como weak-signal.

export function summarizeQualityAudit(evt) {
  const findings = Array.isArray(evt?.findings) ? evt.findings : [];
  const byType = {};
  let errors = 0;
  for (const f of findings) {
    const t = (f && typeof f.type === 'string' && f.type) || 'other';
    byType[t] = (byType[t] || 0) + 1;
    if (f?.severity === 'error') errors += 1;
  }
  return {
    source: (evt && typeof evt.source === 'string' && evt.source) || 'deliverable',
    total: findings.length,
    errors,
    byType,
  };
}
